(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  function closeMenus(event) {
    const header = document.querySelector('.cchw-selector-header');
    if (!header) return;
    const escape = event.type === 'keydown' && event.key === 'Escape';
    if (event.type === 'keydown' && !escape) return;
    header.querySelectorAll('details[open]').forEach(menu => {
      if (escape || !menu.contains(event.target)) {
        menu.open = false;
        if (escape && menu.contains(document.activeElement)) menu.querySelector('summary').focus();
      }
    });
  }
  document.addEventListener('toggle', function(event) {
    if (event.target.matches('.cchw-selector-search-mobile, .cchw-selector-search-desktop') && event.target.open) event.target.querySelector('input').focus();
  }, true);
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', closeMenus);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skip-links"]) return;
  try {
    
  $( document ).ready(function() {
    $( ".cchw-skip-links li a").unbind();
  });

  } catch(e) { console.error(e); }
})();
})();
